/* SP Breadcrumb — inyecta migas de pan en los tipos de página que NO las traen
   (policies [built-in de Shopify], carrito, 404, /collections, contacto…).
   Reutiliza los estilos .sp-pbc del tema. No toca páginas que ya tienen migas
   (producto, colección, blog, artículo, página, búsqueda) ni la home. */
(function () {
  'use strict';

  function firstLine(el) {
    if (!el) return '';
    var lines = (el.textContent || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
    return lines[0] || '';
  }
  function hasBreadcrumb() {
    return !!document.querySelector('.sp-bc, .sp-pbc, .sp-bbc, .sp-article__crumbs, [class*="breadcrumb"]');
  }
  function localeRoot() {
    var m = location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    return (m && m[1]) ? m[1] + '/' : '/';
  }
  function isRoot() {
    var p = location.pathname.replace(/\/+$/, '');
    return p === '' || /^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(p);
  }
  function build(label, root) {
    var nav = document.createElement('nav');
    // Mismas clases que la sección sp-page-breadcrumb de la plantilla de página → mismo estilo y ancho.
    nav.className = 'sp-pbc sp-pbc--injected section section--page-width color-scheme-1';
    nav.setAttribute('aria-label', 'Migas de pan');
    nav.style.setProperty('--sp-pbc-pt', '24px');
    nav.style.setProperty('--sp-pbc-pb', '8px');
    nav.innerHTML =
      '<ol class="sp-pbc__list">' +
        '<li class="sp-pbc__item"><a class="sp-pbc__link" href="' + root + '">Inicio</a></li>' +
        '<li class="sp-pbc__sep" aria-hidden="true">/</li>' +
        '<li class="sp-pbc__item sp-pbc__item--current" aria-current="page"></li>' +
      '</ol>';
    nav.querySelector('.sp-pbc__item--current').textContent = label;
    return nav;
  }

  function run() {
    if (hasBreadcrumb() || isRoot()) return;
    if (document.querySelector('form[action="/password"], .storefront-password-form, input[name="password"]')) return;

    var root = localeRoot();
    var path = location.pathname.replace(/\/+$/, '');

    var main = document.querySelector('main.content-for-layout') || document.querySelector('main');
    if (!main || main.querySelector('.sp-pbc--injected')) return;

    // Título actual según el tipo de página.
    var label = '';
    var policyTitle = firstLine(document.querySelector('.shopify-policy__container .shopify-policy__title h1'));
    if (policyTitle) label = policyTitle;                               // policies
    else if (/\/cart$/.test(path)) label = 'Carrito';                   // carrito
    else if (/\/collections$/.test(path)) label = 'Colecciones';        // /collections
    else label = firstLine(main.querySelector('h1'));                   // 404, contacto, etc.
    if (!label) return;

    // SIEMPRE arriba de <main>, con las mismas clases/posición que la plantilla de página → coherente en toda la tienda.
    main.insertBefore(build(label, root), main.firstChild);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
